import request from "superagent";

const baseUrl = "https://playo.io/api/";
const auth = "5534898698eb3426d00168b6ed447d23d000026552ed6200";

class Api {
  static saveLocation(attach) {
    return new Promise((resolve, reject) => {
      request
        .post("/api/web/v1/saveLocation")
        .send(attach)
        .set("Authorization", auth)
        .set("Accept", "application/json")
        .end((error, res) => {
          error ? reject(error) : resolve(res);
        });
    });
  }

  static getAddress(lat, lng) {
    return new Promise((resolve, reject) => {
      request
        .post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng)
        .set("Accept", "application/json")
        .end((error, res) => {
          error ? reject(error) : resolve(res);
        });
    });
  }

  static hitDeepLinking(attach) {
    return new Promise((resolve, reject) => {
      request
        .post("https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDVI1-E9InjnzmiYlP25PSMdRVArTMXQ_s")
        .send(attach)
        .set("Accept", "application/json")
        .end((error, res) => {
          error ? reject(error) : resolve(res);
        });
    });
  }

  static fetchAllOffers(param) {
    return new Promise((resolve, reject) => {
      request
        .get(baseUrl + "web/v1/offers/?" + param)
        .set("Authorization", auth)
        .set("Accept", "application/json")
        .end((error, res) => {
          error ? reject(error) : resolve(res);
        });
    });
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js